<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="投诉类型"
      edit-title
      id-key="ComplainTypeId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="投诉类型" prop="ComplainTypeName">
          <el-input v-model="data.ComplainTypeName" placeholder="请输入名称" />
        </el-form-item>
       
        <el-form-item label="序号" prop="Sn">
          <el-input type="number" v-model.number="data.Sn" style="width:100px" ></el-input>
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        
          <el-form-item label="状态" prop="Status">
            <el-radio-group v-model="data.Status" class="detail-span">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ComplainTypeId: 0,
        ComplainTypeName: "",
        Status: 1,
        Sn:null,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/complainType").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        TransportNo: [{ required: true, message: "请输入编号" }],
        ComplainTypeName: [{ required: true, message: "请输入类型名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split("/").join(""): location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {},
    onClosed() {
      this.showList = [];
    },
  },
};
</script>